import { faHouse } from '@fortawesome/pro-solid-svg-icons'
import { Icon } from '../../icon/Icon'

export const InitiativeMarker = () => {
  return (
    <Icon
      icon={faHouse}
      size="extra-small"
      style={{ borderRadius: '0.5rem', background: 'var(--brand-accent)' }}
    />
  )
}
